import React from 'react';
import WhatsAppWebShared from '../Shared/WhatsAppWebShared';

const WhatsAppWebManager = () => {
  return <WhatsAppWebShared roleTitle="Manager" />;
};

export default WhatsAppWebManager;
